// extracted by mini-css-extract-plugin
export default {"forbidden":"forbidden_forbidden__j+e3A","lock":"forbidden_lock__jy8GN","dip":"forbidden_dip__3XrWQ","spin":"forbidden_spin__Mp9yZ"};